import { render, staticRenderFns } from "./CustomizedChinaMap.vue?vue&type=template&id=1aa7069c&scoped=true"
import script from "./CustomizedChinaMap.vue?vue&type=script&lang=js"
export * from "./CustomizedChinaMap.vue?vue&type=script&lang=js"
import style0 from "./CustomizedChinaMap.vue?vue&type=style&index=0&id=1aa7069c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa7069c",
  null
  
)

export default component.exports